import React from 'react'

import type { TabItem } from './TabBar'
import { TabBar } from './TabBar'

/**
 * Mobile-native canvas: on a phone it IS the screen (full dvh, internal
 * scroll), on desktop it renders as a centered phone frame so the design
 * always reads as the mobile app (owner's rule: mobile-native first, desktop
 * layout comes later). Content scrolls inside; the tab bar stays put.
 */
export function PhoneShell({ tabs, children }: { tabs?: TabItem[]; children: React.ReactNode }) {
  return (
    // Desktop centering is handled by the app layout (flex items-center)
    <div className="mx-auto flex h-dvh w-full max-w-100 flex-col overflow-hidden bg-cream lg:h-[calc(100dvh-3rem)] lg:max-h-224 lg:rounded-[2.25rem] lg:shadow-2xl lg:ring-8 lg:ring-ink/90">
      {/* data-app-scroll: the one scrollable element of a screen — anything that
          needs to read or drive the scroll position (month scrubber…) finds it
          with closest(), instead of guessing at the window. */}
      <div data-app-scroll className="min-h-0 flex-1 overflow-y-auto">
        {children}
      </div>
      {tabs && <TabBar tabs={tabs} />}
    </div>
  )
}
